import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome,faAngleRight } from '@fortawesome/free-solid-svg-icons'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class Masterblack extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"> <Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active"> Six Sigma Master Black Belt Certification</li>
                    </ol>
                </div>
                <section class="course-header bg-Masterblack11" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg"
                            style={{// eslint-disable-next-line
                                backgroundImage: "url(" + "/assets/images/icons/six-sigma-bkg/six-sigma-symbol.svg" + ")",
                            }}>
                            <h1>Six Sigma Master Black Belt Certification</h1>
                            <br /><br /><br />
                            <div class="form-group">
                                <a href="#apply-nows" class="btn btn-md enroll-btn">Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/six-sigma-master-black-belt-certification-program');" >Download
                                 brochure</button>
                            </div>
                            <br /> <br /><h3> Online Live Training</h3><br /> <br />
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6"><br />
                            <p>Certification jointly awarded by</p>
                            <ul>
                                <li><img alt="executive" src="/assets/images/isi.svg" />  </li>
                                <li><img alt="executive" src="/assets/images/epn.svg" /></li>
                            </ul>
                            <br />
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z" id="Description">
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6" >
                                <b>Schedule: </b><br />
                                <b> <i class="fa fa-calendar" ></i>&nbsp; Upto 12 Days</b><br />
                                <b>(Customisable as per requirements)</b>
                            </div>
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6" >
                                <span class="golden">Training Mode(Online)</span><br />
                                <b> <span class="font-for-batch"><i class="fa fa-calendar-o" aria-hidden="true"></i>  Date :20<sup>th</sup> Mar 2021-25<sup>rd</sup> Apr 2021 </span></b> <br />
                                <b><span class="font-for-batch"><i class="fa fa-film" aria-hidden="true"></i>  Batch Type :Saturday-Sunday </span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Features">Features </a></li>
                            <li><a href="#syllabus">Syllabus</a></li>
                            <li><a href="#Schedule">Schedule</a></li>
                            <li><a href="#Review-s">Learner Review </a></li>
                            <li><a href="#Certification-s">Certification</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-nows">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <br />
                <section class="course-description six-sigma-des" id="course-description">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">An Overview Of The Six Sigma Master Black Belt Course</h3>
                            <p align="justify" >The six sigma master black belt certification program is an advanced level of certification in the field of six sigma. The six sigma master black belt certification training enables a participant to deploy Six Sigma to any organisation as an effective mentor. The six sigma master black belt course effectively trains and coaches the undertaker at all levels including the leadership team, sponsor, champion, six sigma black belt, six sigma green belt, and six sigma yellow belt. The trainees are trained for all the related disciplines including DMAIC, Lean Six Sigma, Design for Six Sigma, and Business Analytics using Data Mining. The six sigma master black belt certification online that is imparted by us will act as a guide to an organisation and enable them to tread on a path of sustainable, predictable, and desirable growth in<span id="Features"></span> profits.</p>
                            <p align="justify" >The Six Sigma Master Black Belt certification in Pune is imparted by the best faculty from the Indian Statistical Institute, Pune. Certified jointly by edu plus now, Pune and Indian Statistical Institute, Pune, the online six sigma master black belt certification in India is highly accredited and covers a comprehensive syllabus without practical knowledge, experience, and exposure. The interactive faculty and engaging syllabus, with a convenient schedule makes it easy for the students and working professionals to attend the sessions.</p>
                        </div>
                    </div>
                    <br />
                    <h3 class="heading-tab">Key Features Of Six Sigma Master Black Belt Course  </h3>
                    Now you can get the best six sigma master black belt certification course in India from the comfort of your homes -
                    <ul class="highlight-ss">
                        <li>	Indian Statistical Institute, Pune as a knowledge partner.</li>
                        <li>	Mentorship by industry specialists.</li>
                        <li>	Seamless EMI options.</li>
                        <li>	Industry-oriented curriculum.</li>
                        <li>	Course awarded by Edu Plus Now and Indian Statistical Institute, Pune.</li>
                    </ul>
                    <br />
                    <h3 class="heading-tab"> Who Will Benefit From The Six Sigma Master Black Belt Course ? </h3>
                    <ul class="highlight-ss">
                        <li>	Professionals who wish to solve business problems using a structured approach can benefit from the course.</li>
                        <li>	Anyone who wants to improve the overall organisational performance.</li>
                        <li>	Process improvement team members who wish to carry out improvement projects.</li>
                        <li>	Any progressive management professional who wants to bring change for the better.</li>
                        <li>Anyone who wants to build competence that is domain-independent.</li>
                    </ul>
                    <br />
                    <h3 class="heading-tab" id="syllabus"> Eligibility Criteria For The Six Sigma Master Black Belt Course </h3>
                    <ul class="highlight-ss">
                        <li>	Must be a certified Six Sigma Black Belt.</li>
                        <li>	Must have completed at least 3 six sigma black belt level projects.</li>
                    </ul>
                </section>
                <section class="course-syllabus" id="course-syllabus">
                    <div class="row" >
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                            <h3>Program Curriculum</h3>
                            <br />
                            <div class="syl-bg">
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a><i class="indicator fa fa-minus"></i> Introduction</a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul" >
                                                        <li>Vision & Mission, HosinKanri, SWOT, Balance Scorecard, Business level dashboard, Annual Business Plan (ABP), Strategic Business Plan (SBP), Multigenerational Process (MGP)and MGAP (Multi generation annual plan), Six Sigma linked to business benefit, Six Sigma Deployment Strategies- Business Process Management Systems, DMAIC, Lean Six Sigma and DFSS Organisation for Six Sigma, Role clarity and certification requirements, Project hopper, Project selection methodologies, Change Acceleration Process</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a><i class="indicator fa fa-minus"></i>Refreshing DMAIC</a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul" >
                                                        <li> Project Hopper, Project Charter, Voice of Customer, Critical to Quality, Tree Diagram, Pareto, SIPOC Type
                                                        of Data, Measurement System Analysis – Variable & Attribute, R&R Study, Sampling, Base level
                                                        Assessment, Normality tests, Capability analysis – Cp, Cpk Pp, Ppk, Defect & defective, DPMO, DPO,
                                                        DPU, Sigma Level Process Analysis – Basic Flow Chart, Activity & Deployment flow chart, Opportunity
                                                        Flow Chart. Problem Analysis, Sporadic Problems, Chronic Problems, Unstable Process, Control Charts,
                                                        Test of Hypothesis, Tabular Analysis, Chi – Square test, Regression Analysis, Process FMEA, Real cause
                                                        identification TRIZ, Solution Prioritization matrix, Solution Matrix, RICI – Chart, Before After tests,
                                                        Solution Implementation, Design of Experiments - Taguchi, ANOVA Control Plan, Control Charts for
                                                        Online Analysis, Mistake Proofing, Kaizen Philosophy, Overall Review, Evaluation Test
                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a><i class="indicator fa fa-minus"></i>Lean Six Sigma</a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul" >
                                                        <li><b>DFSS</b></li>
                                                        <li><b>Define Phase</b>
                                                            <ul >
                                                                <li>Project charter, VSM- CS</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Measure Phase</b>
                                                            <ul >
                                                                <li>Waste related CTQs, Spaghetti chart, Routing card</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Analyse Phase</b>
                                                            <ul >
                                                                <li>Seven Point Waste</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Improve Phase</b>
                                                            <ul >
                                                                <li>VSM-FS, Kaizen- Takt time, Heijunka box, Pull-JIT, 5-S, SMED, ANDON, Poka Yoke, Jidokha,
                                                                Supermarket, Suggestion system, TPM
                                            </li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Control Phase</b>
                                                            <ul >
                                                                <li>Report-out</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Define Phase</b>
                                                            <ul >
                                                                <li>Project charter</li>
                                                                <li>MGP-MGAP</li>
                                                                <li>Conjoint analysis</li>
                                                                <li>Contextual enquiry</li>
                                                                <li>ECTQ Dashboard</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Measure Phase</b>
                                                            <ul >
                                                                <li>QFD</li>
                                                                <li>Design scorecard</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Analyse Phase</b>
                                                            <ul >
                                                                <li>Transfer functions</li>
                                                                <li>Simulation</li>
                                                                <li>DFX</li>
                                                                <li>Axiomatic design</li>
                                                                <li>TRIZ</li>
                                                                <li>Pugh Matrix</li>
                                                                <li>Fault tree analysis</li>
                                                                <li>Relaibility Analysis</li>
                                                                <li>FMEAs</li>
                                                                <li>Tolerance design</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Design Phase</b>
                                                            <ul >
                                                                <li>Design competencies</li>
                                                                <li>Design components- Design configurations</li>
                                                                <li>P-R Map</li>
                                                                <li>Control plans</li>
                                                            </ul>
                                                        </li>
                                                        <li><b>Verify Phase</b>
                                                            <ul >
                                                                <li>ECTQ Dashboard</li>
                                                                <li>Control plans</li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a><i class="indicator fa fa-minus"></i>Business Analytics using Data Mining</a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul" >
                                                        <li>Introduction to Business Analytics using Data Mining</li>
                                                        <li>Data Preparation</li>
                                                        <li>Outlier Analysis</li>
                                                        <li>Data Normalisation</li>
                                                        <li>Data Dimension Reduction (Principal Factor Analysis & FA)</li>
                                                        <li>Data Visualisation</li>
                                                        <li>Classification (Logistic regression, Decision tree, CART)</li>
                                                        <li>Clustering concept</li>
                                                        <li>Affinity analysis (Market basket Analysis concept)</li>
                                                        <li>Predictive analytic including Time series forecasting</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="dv_heading5" data-toggle="collapse"
                                                href="#dv_syllabus5" aria-expanded="true" aria-controls="dv_syllabus5">
                                                <h6 class="panel-title">
                                                    {// eslint-disable-next-line
                                                    } <a><i class="indicator fa fa-minus"></i> Examination </a>
                                                </h6>
                                            </div>
                                            <div id="dv_syllabus5" class="collapse show" aria-labelledby="dv_heading5"
                                                data-parent="#dv_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul" >
                                                        <li> Theory Session</li>
                                                        <li > Presentation Session</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-admission-process bg-white" id="course-admission-process">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <h3 class="heading-tab"> Skill One Must Possess For Having A Successful Career As A Six Sigma Practitioner </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>	Having a positive and optimistic attitude.</li>
                                <li>	Possessing a firm belief in completing the tasks and achieving the goals.</li>
                                <li>	Keen and possessing the ability to take initiatives.</li>
                                <li>	Having excellent analytical and problem-solving skills.</li>
                                <li>	Having the ability to manage project teams.</li>
                                <li>	Being able to motivate peers.</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>	Having excellent communication skills.</li>
                                <li>	Having good writing skills and being able to present them.</li>
                                <li id="Schedule">	Possessing the know-how and understanding of business processes.</li>
                                <li>	Having the ability to manage budgets.</li>
                                <li>	Being able to allocate company resources optimally.</li>
                                <li>	Be hard-working and result-oriented.</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Exam and Certification</h3>
                            <br />
                            <ul >
                                <li>Six Sigma Master Black Belt Certificate will be issued after successful completion of Content Test and a Test of Presentation Skills with <FontAwesomeIcon icon={faAngleRight} />=80% marks in the test conducted on the last day of the session.</li>
                                <br />
                                <li> We also issue a Master Black Belt ID card to the MBB once he mentored at least five Six Sigma Black-Belt level projects and completed at least 100 hours of training session within one year from the date of issue of the MBB Certificate.</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img src="/assets/images/icons/certificate-final.png" alt="Six Sigma Master Black Belt Certification" />
                            <br /><br />
                            <p class="img-below-text text-center" id="apply-nows">Awarded Jointly by The Indian Statistical Institute,Pune and
                             edu plus now </p>
                            <br /><br />
                        </div>
                    </div>
                </section>
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li>	Indian Statistical Institute, Pune as a knowledge partner.</li>
                                            <li>	Mentorship by industry specialists.</li>
                                            <li>	Seamless EMI options.</li>
                                            <li>	Industry-oriented curriculum.</li>
                                            <li>	Course awarded by Edu Plus Now and Indian Statistical Institute, Pune.</li>
                                        </ul>
                                    </div>
                                    <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About the Organization</h3>
                            <br />
                            <img alt="masterblack3" width="" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                                 </p>

                            <br />
                            <p align="justify">ISI Pune is a unit of Indian Statistical Institute,Pune, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                                     Data Analytic, Data Science. </p>
                        </div>
                    </div>
                </section>
                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                 <div class="modal-dialog modal-md">
                     <div class="modal-content">
                         <div class="modal-header" >
                             <span class="close" id="close_form" data-dismiss="modal">&times;</span>
                        <br />      
                         </div>
                         <div class="modal-body" >
                             <div class="panel panel-default paper-shadow box_detail" >
                                 <h5 class="text-center "> Download The Course Brochure </h5>
                                 <form method="post" class="form-row"  onsubmit="return validate()">
                                     <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                         required="" autocomplete="on" name="name" id="name" />
                                     <b>Your email</b><input class="form-control" type="email" required=""
                                         autocomplete="on" name="emaill" id="emaill" />
                                     <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                         type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                     <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                     <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                     <br />
                                     <div>
                                         <div class="form-group">
                                         <div  id="recaptcha" class="g-recaptcha"
                                             data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                             <div id="captcha"></div>
                                         </div>
                                     </div>
                                     <div class="mob_cb" >
                                         <div>
                                         </div><br />
                                          <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                     <br /> 
                                 </form>
                             </div>
                         </div>
                     </div>

                 </div>

             </div>
            </div>
        );
    }
}

export default Masterblack;